module.exports = "/_next/static/resources/photo-1-df4842db1211c13ebcbaade9d2caa396.jpg";